// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取系统健康状态 GET /api/v1/hq/monitoring */
export async function HqMonitoringControllerGetHealthV1(options?: {
  [key: string]: any;
}) {
  return request<any>("/api/v1/hq/monitoring", {
    method: "GET",
    ...(options || {}),
  });
}
